import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { I18nProvider } from "./i18n/I18nContext";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import QuoteRequest from "./pages/QuoteRequest";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import "./App.css";

const Local = ({ locale, children }) => <I18nProvider locale={locale}>{children}</I18nProvider>;

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // wait a tick so the target section is in the DOM
      const id = hash.replace("#", "");
      const tryScroll = (attempts = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempts < 10) {
          setTimeout(() => tryScroll(attempts + 1), 80);
        }
      };
      tryScroll();
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const LangRedirect = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const lang = (navigator.language || "fr").toLowerCase();
    navigate(lang.startsWith("de") ? "/de" : "/fr", { replace: true });
  }, [navigate]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<LangRedirect />} />

          <Route path="/fr" element={<Local locale="fr"><Home /></Local>} />
          <Route path="/fr/contact" element={<Local locale="fr"><Contact /></Local>} />
          <Route path="/fr/devis" element={<Local locale="fr"><QuoteRequest /></Local>} />

          <Route path="/de" element={<Local locale="de"><Home /></Local>} />
          <Route path="/de/kontakt" element={<Local locale="de"><Contact /></Local>} />
          <Route path="/de/offerte" element={<Local locale="de"><QuoteRequest /></Local>} />

          {/* Redirect retired pages to homepage anchors */}
          <Route path="/fr/desinfection" element={<Navigate to="/fr#desinfection" replace />} />
          <Route path="/fr/formules" element={<Navigate to="/fr#devis" replace />} />
          <Route path="/fr/tarifs" element={<Navigate to="/fr#devis" replace />} />
          <Route path="/de/desinfektion" element={<Navigate to="/de#desinfection" replace />} />
          <Route path="/de/formeln" element={<Navigate to="/de#devis" replace />} />
          <Route path="/de/tarife" element={<Navigate to="/de#devis" replace />} />

          <Route path="/checkout/success" element={<Local locale="fr"><CheckoutSuccess /></Local>} />
          <Route path="/checkout/cancel" element={<Local locale="fr"><CheckoutCancel /></Local>} />
          <Route path="/payment-success" element={<Local locale="fr"><CheckoutSuccess /></Local>} />
          <Route path="/payment-cancelled" element={<Local locale="fr"><CheckoutCancel /></Local>} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />

          <Route path="*" element={<Navigate to="/fr" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
